module.exports = __webpack_public_path__ + "img/2.628fe0d4.png";